module.exports = __webpack_public_path__ + "media/images/flags/ar-64f19246b47680747fcb8870cae80389.svg";